"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = exports.StyledLink = exports.LayoutOptions = exports.Options = exports.HandleButton = exports.BinButton = exports.ButtomMargin = exports.Overlay = exports.ImgWrapper = exports.DropZone = exports.columnStyles = exports.StyledImgInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const Button_1 = require("../../../Button");
const Loading_1 = require("../../../Loading");
exports.StyledImgInput = app_1.styled.div `
  position: relative;
  display: grid;
  flex-wrap: wrap;
  gap: ${(theme) => theme.spacing.small};
  height: 100%;
`;
exports.columnStyles = [
    null,
    (0, app_1.css) `
    grid-template-columns: 1fr;
  `,
    (0, app_1.css) `
    grid-template-columns: 1fr 1fr;
  `,
    (0, app_1.css) `
    grid-template-columns: 1fr 1fr 1fr;
  `,
];
exports.DropZone = app_1.styled.div `
  color: ${(theme) => theme.colors.gray};
  border: 0.0625rem dashed ${(theme) => theme.stroke};
  padding: 2rem 0.625rem;
  height: 100%;
  ${(theme) => theme.flexCenter};
  flex-direction: column;
  border-radius: ${(theme) => theme.radius.big};
`;
exports.ImgWrapper = app_1.styled.div `
  position: relative;
  border-radius: ${(theme) => theme.radius.big};
  height: 10rem;
  overflow: hidden;
  width: 100%;
  margin-bottom: 1rem;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  &:not(:hover) > button {
    display: none;
  }
`;
exports.Overlay = app_1.styled.div `
  ${(theme) => [theme.overlay, theme.flexCenter]};
  background-color: rgba(255, 255, 255, 0.8);
  font-size: 2rem;
  > svg {
    width: 3rem;
    height: 3rem;
    margin-left: 1rem;
  }
`;
exports.ButtomMargin = (0, app_1.styled)(Button_1.Button) `
  margin-top: ${(theme) => theme.spacing.small};
`;
exports.BinButton = (0, app_1.styled)(Button_1.Button) `
  position: absolute;
  bottom: ${(theme) => theme.spacing.small};
  right: ${(theme) => theme.spacing.small};
`;
exports.HandleButton = (0, app_1.styled)(Button_1.Button) `
  position: absolute;
  top: ${(theme) => theme.spacing.small};
  right: ${(theme) => theme.spacing.small};
`;
exports.Options = app_1.styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
exports.LayoutOptions = app_1.styled.div `
  display: flex;
  align-items: center;
  > svg {
    color: ${(theme) => theme.colors.gray};
  }
  > * {
    cursor: pointer;
    margin-left: 1rem;
  }
`;
exports.StyledLink = (0, app_1.styled)(app_1.Link) `
  font-size: 0.875rem;
  color: ${(theme) => theme.colors.primary};
`;
function Image(_a) {
    var { src, img, dragHandleProps, onRemove } = _a, props = __rest(_a, ["src", "img", "dragHandleProps", "onRemove"]);
    return ((0, jsx_runtime_1.jsx)(exports.ImgWrapper, { children: src || img ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(img === null || img === void 0 ? void 0 : img.thumb) ? ((0, jsx_runtime_1.jsx)(app_1.Image, { img: img, customContext: true, context: img.context, sizes: "700px" })) : ((0, jsx_runtime_1.jsx)("img", Object.assign({ src: src, alt: "Uploaded content" }, props))), (0, jsx_runtime_1.jsx)(exports.HandleButton, Object.assign({ kind: ['icon', 'secondary'] }, dragHandleProps, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgHandle, {}) })), (0, jsx_runtime_1.jsx)(exports.BinButton, Object.assign({ kind: ['icon', 'secondary'], onClick: onRemove }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgBin, {}) }))] })) : ((0, jsx_runtime_1.jsx)(Loading_1.LoadingOverlay, {})) }));
}
exports.Image = Image;
